export const DEFAULT_DOCUMENT_TITLE = 'Lender Optimus';
export const DEFAULT_FAVICON_HREF = process.env.PUBLIC_FAVICON || '/lender-dev.ico';
export const FAVICON_LINK_SELECTOR = "link[rel='shortcut icon'], link[rel='icon']";
